import React from 'react';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Icon from 'antd/lib/icon';
import TableAthleteCsv from './TableAthleteCsv';
import ButtonAction from '../../components/utilities/ButtonAction';
var cardStyles = require('src/imports/styles/extend.card.scss');
var formStyles = require('src/imports/styles/extend.form.scss');
var selfStyles = require('./styles.scss');
var FormReview = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("section", { className: selfStyles.formSection },
        React.createElement("h2", { className: cardStyles.header }, "Step 4"),
        React.createElement("h4", null, "Review and edit errors in data (table scrolls to the right)"),
        React.createElement(TableAthleteCsv, { isDisabled: props.isDisabled, isTeamCategory: props.category.isTeamCategory, emptyText: 'No errors found, please go to Step 5', athletes: props.errorAthletes, handleUpdateRow: props.handleUpdateErrorAthlete }),
        React.createElement(ButtonAction, { width: '100%', isDisabled: props.errorAthletes.length === 0 || props.isDisabled },
            React.createElement("button", { onClick: function () { return props.handleCsvData(props.validAthletes.concat(props.errorAthletes)); } }, "Review changes"))),
    React.createElement("section", { className: selfStyles.formSection },
        React.createElement("h2", { className: cardStyles.header }, "Step 5"),
        React.createElement("h4", null,
            "You have uploaded ",
            React.createElement("strong", null, props.validAthletes.length + props.errorAthletes.length),
            " rows of data (valid: ",
            props.validAthletes.length,
            ", error: ",
            props.errorAthletes.length,
            ")."),
        React.createElement("h4", null,
            "You will import ",
            React.createElement("strong", null, props.validAthletes.length),
            " athletes into ",
            React.createElement("strong", null, props.category.name),
            " if you continue."),
        React.createElement("div", { className: formStyles.buttonsWrapper },
            React.createElement("div", { className: formStyles.buttonsLeft },
                React.createElement(Form.Item, null,
                    React.createElement(ButtonAction, { className: selfStyles.actionButtonCancel, isDisabled: props.isDisabled },
                        React.createElement("button", { className: selfStyles.actionButtonCancelButton, onClick: function () { return history.back(); } },
                            React.createElement(Icon, { type: 'close-circle-o' }),
                            " Cancel")))),
            React.createElement("div", { className: formStyles.buttonsRight },
                React.createElement(Form.Item, null,
                    React.createElement(ButtonAction, { className: selfStyles.actionButtonSubmit, isDisabled: props.validAthletes.length === 0, isWaiting: props.isDisabled },
                        React.createElement("button", { onClick: props.handleSubmitForm },
                            React.createElement(Icon, { type: 'check-circle' }),
                            " Add athletes"))))),
        React.createElement(TableAthleteCsv, { isDisabled: true || props.isDisabled, isTeamCategory: props.category.isTeamCategory, emptyText: 'No valid data uploaded in file', athletes: props.validAthletes, handleUpdateRow: props.handleUpdateValidAthlete })))); };
export default FormReview;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthleteCsvPage/FormReview.tsx
// module id = 1318
// module chunks = 0